import { render, staticRenderFns } from "./CallMailSupportButtons.vue?vue&type=template&id=471e2112"
import script from "./CallMailSupportButtons.vue?vue&type=script&lang=js"
export * from "./CallMailSupportButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports